import React from 'react';
import { FlexCol } from 'components/primitives/flex';
import PageHeader from 'components/auth/components/PageHeader';
import SocialLoginButtonsV2 from 'components/auth/components/SocialLoginButtonsV2';
import useTrackComponentMount from 'hooks/useTrackComponentMount';
import EmailIdentifierStep from './EmailIdentifierStep';

const IdentifierStep = () => {
  useTrackComponentMount('show_form', {
    component_type: 'form',
    object: 'log_in_or_sign_up_form',
  });

  return (
    <FlexCol gap="20px">
      <PageHeader title="Log in or sign up" />
      {/* TODO: Add phone identifier step when we decide to add phone as a primary identifier */}
      {/* {identifierType === 'phone' ? <PhoneIdentifierStep /> : <EmailIdentifierStep />} */}
      <EmailIdentifierStep />
      <SocialLoginButtonsV2 />
    </FlexCol>
  );
};

export default IdentifierStep;
